import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getUserPermissions } from '../../reducers';

const mapStateToProps = state => ({
    userPermissions: getUserPermissions(state)
});

const LegendFilterItem = ({ value, onClick, isActive, title }) => (
    <button
        className={classNames(`legend-filter legend-filter--${value}`, {
            disabled: !isActive
        })}
        onClick={onClick}
        value={value}
    >
        <span className="legend-icon">
            <svg className="icon icon-checkmark">
                <use xlinkHref="#icon-checkmark" />
            </svg>
        </span>
        <span className="legend-title">{title}</span>
    </button>
);

const LegendFilter = ({ filters, toggleFilter, userPermissions }) => {
    let filterObjs = [
        {
            value: 'creation',
            title: 'Event Creation'
        },
        {
            value: 'review',
            title: 'Event Review'
        },
        {
            value: 'aaIncomplete',
            title: 'After Action Incomplete'
        },
        {
            value: 'aaReview',
            title: 'After Action Review'
        },
        {
            value: 'aaPending',
            title: 'After Action Pending'
        }
    ];

    if (!userPermissions.Event.includes('Create')) {
        filterObjs.splice(0, 1);
    }
    return (
        <div className="legend">
            {filterObjs.map(({ title, value }, index) => {
                return (
                    <LegendFilterItem
                        key={index}
                        value={value}
                        title={title}
                        onClick={() => toggleFilter(value)}
                        isActive={filters.includes(value)}
                    />
                );
            })}
        </div>
    );
};

export default connect(mapStateToProps)(LegendFilter);



// WEBPACK FOOTER //
// ./src/components/calendar/legendfilter.js